<template>
    <StepTemplate :activeStepNr="this.activeStepNr"
                  :myStepNr="this.myStepNr"
                  :value="value"

    >
        <template slot="slide-form">
            <form data-vv-scope="xxx" @click.alt="testFillForm()">
                <!--============================================================================================================-->
                <!--
                <v-layout row>
                    <v-flex xs11 class="mt-2"><h5>{{this.label}}</h5></v-flex>
                </v-layout>
                -->
                <!--============================================================================================================ -->
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Antrag-Daten</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <v-flex xs12 style=" font-size: 0.9em;">
                        <Anzeigepflicht-Block><!-- TextBlock mit Hinweis zur Pflicht alle Daten korrekt anzugeben--></Anzeigepflicht-Block>
                    </v-flex>
                </v-layout>

                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        <br>Der Beginn ist frühestens am nächsten Tag möglich.
                        <br>Der Versicherungsbeginn sollte jedoch maximal einen Tag später sein, zu dem Ihre bisherige Versicherung aufgehoben wurde.
                        <br>
                    </Rechner-hint-col>

                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_beginn" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Hier können Sie wählen, ob der Versicherungs-Beitrag einmal im Jahr, halbjährlich oder
                        vierteljährlich gezahlt werden soll.
                        <br>Eine monatliche Zahlweise ist nicht möglich.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.vertrag_zahlungsweise" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>



                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Adresse der Baustelle</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row>
                    <Rechner-hint-col>
                        Tragen Sie hier die Straße und Hausnummer ein, in der sich Ihr Haus/Grund befindet.
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.bau_lage_strasse" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Tragen Sie hier die Postleitzahl und den Ort ein, in der sich Ihr Haus/Grund befindet.
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.bau_lage_plz" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>
                    <v-flex xs6>
                        <Rechner-field-col ref="selectOrt" :fielddef="fieldDefs.bau_lage_ort" v-model="value.fieldValues"
                                           :$v="$v" menuIsActive="selectInput_ort_open"></Rechner-field-col>
                    </v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>





                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row class="section_header">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Art des Gebäudes</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Die Art des Gebäudes
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.bau_gebaeudeArt" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>


                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Die Art der Nutzung
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.bau_nutzungsArt" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        Die Art der Baumaßnahmen
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.bau_umbauArt" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row>
                    <Rechner-hint-col>
                        die Bauart des Gebäudes
                    </Rechner-hint-col>
                    <v-flex xs10>
                        <Rechner-field-col :fielddef="fieldDefs.bau_BauartKlasse" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>



                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row class="section_header" v-if="value.fieldValues.bau_gebaeudeArt === 'MFH'">
                    <v-flex xs11 class="mt-2 blue-grey lighten-4"><h6>Art der Baumaßnahmen</h6></v-flex>
                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <v-layout row v-if="(value.fieldValues.bau_gebaeudeArt === 'MFH')">
                    <Rechner-hint-col>
                        die Bausumme der baulichen Maßnahme
                        <br>
                        <br>
                        enthält die bauliche Maßnahme auch Eigenleistung?
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.bau_MFH_bauSumme" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>


                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.bau_MFH_eigenRegie_jn" v-model="value.fieldValues" direction="row"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>
                <v-layout row v-if="(value.fieldValues.bau_gebaeudeArt === 'MFH' && parseInt(value.fieldValues.bau_MFH_eigenRegie_jn ,10)=== 1)">
                    <Rechner-hint-col>
                        der Wert der erbrachten Eigenleistung
                        <br>
                        <br>
                        enthält die bauliche Maßnahme auch Eigenleistung?
                    </Rechner-hint-col>
                    <v-flex xs4>
                        <Rechner-field-col :fielddef="fieldDefs.bau_MFH_eigenLeistSumme" v-model="value.fieldValues"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                    <v-flex xs6>
                        <Rechner-field-col :fielddef="fieldDefs.bau_MFH_mitMaschinen_jn" v-model="value.fieldValues" direction="row"
                                           :$v="$v"></Rechner-field-col>
                    </v-flex>

                </v-layout>
                <!------------------------------------------------------------------------------------------------------------>

                <!--============================================================================================================-->
            </form>

        </template>
    </StepTemplate>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    import slideMixin from '../stepMixin'
    import _ from 'lodash'
    //import VueUploadComponent from 'vue-upload-component'
    //import VBtn from 'vuetify/src/components/VBtn/VBtn'
    //import {mapState} from 'vuex'

    /*
    const STATUS_INITIAL = 0
    const STATUS_SAVING = 1
    const STATUS_SUCCESS = 2
    const STATUS_FAILED = 3
*/
    export default {
        //========================================================================================================
        name: 'Step_bauherren_I',
        label: 'bauherren Daten',
        label2: 'bauherren<br>Daten',


        fieldKeys: [
            'bau_gebaeudeArt',
            'bau_nutzungsArt',
            'bau_umbauArt',
            'bau_BauartKlasse',

            'bau_lage_strasse',
            'bau_lage_plz',
            'bau_lage_ort',

            'bau_MFH_bauSumme',
            'bau_MFH_eigenRegie_jn',
            'bau_MFH_eigenLeistSumme',
            'bau_MFH_mitMaschinen_jn',


            'vertrag_zahlungsweise',
            'vertrag_beginn',
        ],
        //========================================================================================================
        data: function () {
            //fieldDefs wird in StepMixin mit den Werten aus der Datenbank belegt,
            //an dieser Stelle können diese Werte überschrieben werden.
            // Vue merged von alleine die Werte aus 'stepMixin' und denen aus 'fieldDefs_OVERRIDE'
            var fieldDefs_OVERRIDE = {}


            return {
                fieldDefs: fieldDefs_OVERRIDE,

            }
        }, //========================================================================================================
        mixins: [slideMixin],
        //========================================================================================================
        computed: {},  //===========================================================================================================
        methods: {

            test: function () {
                this.$v.$touch()
                console.log("TEST1")
            },

        },  //===========================================================================================================
        watch: {

            value: {
                handler: function (newVal, oldVal) {
                    console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
                    console.log('WATCHER fieldValues in ', this.$options.label)
                    // var fD = this.fieldDefs
                    var fV = this.value.fieldValues
                    var fVold = this.frmValuesOld
                    var earlyExit = true

                    // console.log('TEST ', fV.bauherren_art_pkw_nfz, (fV.bauherren_art_pkw_nfz === "PKW") * 1)

                    for (var key in fV) {
                        console.log('Watcher TEST :', key, ":", fV[key], " -> ", fVold[key])
                        if (fV[key] !== fVold[key]) {
                            earlyExit = false
                            this.update_Ort_by_PLZ(key)
                        }
                    }
                    if (earlyExit === true) {
                        console.log('NO changes -> early EXIT')
                        return
                    }
                    console.log('FOUND changes -> check handlers ...')

                    //----------------------------------------------------------------------------
                    // -> hier evtl. Reaktion auf Änderungen von Form-Values
                    /*------------------------------------------------------------------------------------*/
                    if (fV['bau_gebaeudeArt'] === "MFH" && fVold['bau_gebaeudeArt'] != fV['bau_gebaeudeArt']) {
                        this.value.fieldValues['bau_MFH_bauSumme'] = null;
                        this.value.fieldValues['bau_MFH_eigenRegie_jn'] = null;
                        this.value.fieldValues['bau_MFH_eigenLeistSumme'] = null;
                        this.value.fieldValues['bau_MFH_mitMaschinen_jn'] = null;
                        console.log("WATCHER: update bau_gebaeudeArt TO MFH => alle MFH-field to NULL ")
                    }
                    if (fV['bau_gebaeudeArt'] !== "MFH" && fVold['bau_gebaeudeArt'] != fV['bau_gebaeudeArt']) {
                        this.value.fieldValues['bau_MFH_bauSumme'] = 0;
                        this.value.fieldValues['bau_MFH_eigenRegie_jn'] = 0;
                        this.value.fieldValues['bau_MFH_eigenLeistSumme'] = 0;
                        this.value.fieldValues['bau_MFH_mitMaschinen_jn'] = 0;
                        console.log("WATCHER: update bau_gebaeudeArt TO EFH/ZFH/FH => alle MFH-field to -1/OFF etc ")
                    }
                    /*------------------------------------------------------------------------------------*/
                    if (parseInt(fV['bau_MFH_eigenRegie_jn'],10) !== 1 && fVold['bau_MFH_eigenRegie_jn'] != fV['bau_MFH_eigenRegie_jn']) {
                        this.value.fieldValues['bau_MFH_eigenLeistSumme'] = 0;
                        this.value.fieldValues['bau_MFH_mitMaschinen_jn'] = 0;
                        console.log("WATCHER: update bau_MFH_eigenRegie_jn TO 0/null => eigenLeistSum & BauMachinen TO 0 ")
                    }
                    if (parseInt(fV['bau_MFH_eigenRegie_jn'],10) == 1 && fVold['bau_MFH_eigenRegie_jn'] != fV['bau_MFH_eigenRegie_jn']) {
                        this.value.fieldValues['bau_MFH_eigenLeistSumme'] = null;
                        this.value.fieldValues['bau_MFH_mitMaschinen_jn'] = null;
                        console.log("WATCHER: update bau_MFH_eigenRegie_jn TO 1 => eigenLeistSum & BauMachinen TO null ")
                    }
                    /*------------------------------------------------------------------------------------*/
                    this.frmValuesOld = _.assign({}, fV)

                },
                deep: true,

            },
        }
        , //========================================================================================================
        /* ohter components are programmatically setted my step-mixin*/
        components: {}
        ,
        //===========================================================================================================
        props: [/* programmatically setted by step-mixin*/],
        //===========================================================================================================
        // HOOKS:
        /* programmatically setted by step-mixin*/
        mounted: function () {
            //  this.upload_reset()
            //  this.upload_timeTest()

        }

        ,
        //===========================================================================================================
    }
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style>

</style>
